import { render, staticRenderFns } from "./InternalVideoGridItem.vue?vue&type=template&id=28590866&"
import script from "./InternalVideoGridItem.vue?vue&type=script&lang=js&"
export * from "./InternalVideoGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports